module.exports = __webpack_public_path__ + "img/ic_peer_feedback.b08abf0f.png";